var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,9 C8,5.13400675 11.1340068,2 15,2 C18.8659932,2 22,5.13400675 22,9 C22,12.8659932 18.8659932,16 15,16 L13,16 L13,18 L11,18 L11,20 L9,20 L9,22 L2,22 L2,16.5857864 L8.14800517,10.4377813 C8.0499525,9.96846804 8,9.48730703 8,9 Z M11,14 L15,14 C17.7614237,14 20,11.7614237 20,9 C20,6.23857625 17.7614237,4 15,4 C12.2385763,4 10,6.23857625 10,9 C10,9.49863276 10.0726899,9.98638049 10.2140786,10.4528677 L10.3878889,11.0263246 L4,17.4142136 L4,20 L7,20 L7,18 L9,18 L9,16 L11,16 L11,14 Z M15,11 C13.8954305,11 13,10.1045695 13,9 C13,7.8954305 13.8954305,7 15,7 C16.1045695,7 17,7.8954305 17,9 C17,10.1045695 16.1045695,11 15,11 Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.62b5e4fda37d9bf0d90d80c4004c501c.svg";
export { ForwardRef as ReactComponent };